module.exports = __webpack_public_path__ + "static/media/serena-on.59a10551.png";